/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { YearlyDistribution } from './YearlyDistribution';
import {
    YearlyDistributionFromJSON,
    YearlyDistributionFromJSONTyped,
    YearlyDistributionToJSON,
} from './YearlyDistribution';

/**
 * 
 * @export
 * @interface YearlyDistributionsResponse
 */
export interface YearlyDistributionsResponse {
    /**
     * 
     * @type {Array<YearlyDistribution>}
     * @memberof YearlyDistributionsResponse
     */
    distributions: Array<YearlyDistribution>;
}

/**
 * Check if a given object implements the YearlyDistributionsResponse interface.
 */
export function instanceOfYearlyDistributionsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "distributions" in value;

    return isInstance;
}

export function YearlyDistributionsResponseFromJSON(json: any): YearlyDistributionsResponse {
    return YearlyDistributionsResponseFromJSONTyped(json, false);
}

export function YearlyDistributionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): YearlyDistributionsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'distributions': ((json['distributions'] as Array<any>).map(YearlyDistributionFromJSON)),
    };
}

export function YearlyDistributionsResponseToJSON(value?: YearlyDistributionsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'distributions': ((value.distributions as Array<any>).map(YearlyDistributionToJSON)),
    };
}

